var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppInputCurrency',_vm._b({attrs:{"value":_vm.inputValue,"data-test":_vm.dataTest},on:{"change":v => (_vm.inputValue = v),"blur":function($event){return _vm.$emit('blur', $event)}},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_vm._t("append-outer")]},proxy:true}],null,true)},'AppInputCurrency',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }